import { Divider as ChakraDivider } from '@chakra-ui/react';
import { SystemProps } from './primitives.types';

export interface DividerProps extends SystemProps, Omit<React.ComponentPropsWithoutRef<'hr'>, keyof SystemProps> {
  orientation?: 'horizontal' | 'vertical';
}

export function Divider(props: DividerProps) {
  return <ChakraDivider {...props} />;
}